
export enum ThreeLevelStateOfUse {
  Critical= 'Critical',
  Fair= 'Fair',
  Excellent= 'Excellent',

}